<template>
  <v-autocomplete
    label="Médico Escalado por"
    :items="listAdminUsers"
    item-title="name"
    item-value="id"
    :model-value="isLoading ? 'Buscando...' : modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    placeholder="Digite para buscar um usuário..."
    class="w-full"
    color="primary20"
    clearable
    theme="light"
    variant="outlined"
    density="comfortable"
    :loading="isLoading"
    :error-messages="errorMessages"
  >
    <template #item="{ props, item }">
      <v-list-item v-bind="props" :title="item.raw.name" />
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import { VAutocomplete } from 'vuetify/components'
import ScheduleService from '@/Network/Services/ScheduleUnitService'
import { computed, ref, watch } from 'vue'
import { useErrorToast } from '@/composables/useErrorToast'

const props = defineProps<{
  modelValue: number | undefined | null
  schedule: number | null | undefined
  userSponsorIdErr?: string | undefined
}>()

const isLoading = ref(false)

const emit = defineEmits(['update:modelValue'])

const { notifyError } = useErrorToast()

const scheduleService = new ScheduleService()
const listAdminUsers = ref<{ id: number; name: string }[]>([])

const LOAD_ERROR_MESSAGE = 'Não foi possível carregar os responsáveis pela escala.'
const loadError = ref<string | null>(null)

// Sem estado de erro, a lista vazia se confunde com "não há responsáveis
// cadastrados" — o campo precisa dizer que a carga é que falhou.
const errorMessages = computed(() => props.userSponsorIdErr || loadError.value || undefined)

const fetchAdminUsers = async (scheduleId: number) => {
  try {
    isLoading.value = true
    loadError.value = null
    listAdminUsers.value = await scheduleService.stationCreatingUsers(scheduleId)
  } catch (error) {
    listAdminUsers.value = []
    loadError.value = LOAD_ERROR_MESSAGE
    notifyError(error, LOAD_ERROR_MESSAGE)
  } finally {
    isLoading.value = false
  }
}

watch(
  () => props.schedule,
  (newVal) => {
    if (newVal) {
      fetchAdminUsers(newVal)
    } else {
      listAdminUsers.value = []
      loadError.value = null
      emit('update:modelValue', undefined)
    }
  },
  { immediate: true }
)
</script>
